import React, { Component } from 'react'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import FontAwesomeIcon from '@fortawesome/react-fontawesome'
import BackIcon from '@fortawesome/fontawesome-free-solid/faLongArrowAltLeft'

import { TextInput, Button2 } from '../../../common'
import Icon from '../../../common/icon'

import * as Strings from './strings'
import * as Constants from '../../../../helpers/Constants'
import * as Functions from '../../../../helpers/Functions'
import * as userActions from '../../../../actions/User'
import * as configActions from '../../../../actions/Config'

class SignUp extends Component {
  constructor(props) {
    super(props)
    this.state = {
      codeInput: '',
      emailInput: '',
      passwordInput: '',
      repeatPasswordInput: '',
      repeatEmailInput: '',
      phoneInput: ''
    }

    this.enterHandler = this.enterHandler.bind(this)
  }

  componentWillMount() {
    window.addEventListener('keypress', this.enterHandler)

    this.props.tryValidateSession('SE')
  }

  componentWillUnmount() {
    window.removeEventListener('keypress', this.enterHandler)
  }

  enterHandler(e) {
    const { alert } = this.props
    if (e.charCode === 13 && alert.id === null) {
      this.create()
    } else {
      this.props.hideAlert()
    }
  }

  create() {
    const { config } = this.props
    const {
      codeInput,
      emailInput,
      repeatEmailInput,
      passwordInput,
      repeatPasswordInput,
      phoneInput
    } = this.state

    if (
      codeInput === '' ||
      emailInput === '' ||
      passwordInput === '' ||
      (Constants.WHITE_LABEL.features.usePhone && phoneInput === '')
    ) {
      this.props.showAlert(
        Strings.default.MANDATORY_FIELDS[config.language],
        Strings.default.MANDATORY_FIELDS_INFO[config.language],
        Constants.ONE_BUTTON,
        { title: Strings.default.OK[config.language], onPress: () => {} }
      )
    } else if (emailInput !== repeatEmailInput) {
      this.props.showAlert(
        Strings.default.EMAILS_DONT_MATCH[config.language],
        Strings.default.EMAILS_DONT_MATCH_INFO[config.language],
        Constants.ONE_BUTTON,
        { title: Strings.default.OK[config.language], onPress: () => {} }
      )
    } else if (repeatPasswordInput !== passwordInput) {
      this.props.showAlert(
        Strings.default.PASSWORDS_DONT_MATCH[config.language],
        Strings.default.PASSWORDS_DONT_MATCH_INFO[config.language],
        Constants.ONE_BUTTON,
        { title: Strings.default.OK[config.language], onPress: () => {} }
      )
    } else if (!Functions.isValidEmail(emailInput)) {
      this.props.showAlert(
        Strings.default.NOT_VALID_EMAIL[config.language],
        Strings.default.NOT_VALID_EMAIL_INFO[config.language],
        Constants.ONE_BUTTON,
        { title: Strings.default.OK[config.language], onPress: () => {} }
      )
    } else {
      const data = {
        code: codeInput,
        email: emailInput,
        password: passwordInput,
        phone: phoneInput
      }

      this.props.tryCreateUser(data, config.language, (h, i, t, b) =>
        this.props.showAlert(h, i, t, b)
      )
    }
  }

  render() {
    const {
      passwordInput,
      emailInput,
      repeatPasswordInput,
      codeInput,
      repeatEmailInput,
      phoneInput
    } = this.state
    const { config, history, user, data } = this.props

    if (user.fetched) {
      if (data.privileges.laundryBookingSystem) {
        history.push('/laundrybookings')
      } else if (data.privileges.bookingSystem) {
        history.push('/bookingsystems')
      } else if (data.privileges.errorReportSystem) {
        history.push('/newerrorreport')
      } else if (data.privileges.feedSystem) {
        history.push('/news')
      } else if (data.privileges.infoSystem) {
        history.push('/communityinformation')
      } else {
        history.push('/mypage')
      }
    }

    return (
      <div className={'basicCentered'}>
        <div
          onClick={() => this.props.history.push('/')}
          className={'backSection'}
        >
          <FontAwesomeIcon className={'backIcon'} icon={BackIcon} />
          <p className={'backText'}>
            {Strings.default.TO_SIGN_IN[config.language]}
          </p>
        </div>
        <div className={'basicContainer'}>
          <h5>{Strings.default.CREATE_ACCOUNT[config.language]}</h5>
          <Input
            header={Strings.default.APARTMENT_CODE[config.language]}
            value={codeInput}
            onChange={value => this.setState({ codeInput: value })}
          />
          <Input
            header={Strings.default.EMAIL_ADDRESS[config.language]}
            value={emailInput}
            onChange={value => this.setState({ emailInput: value })}
          />
          <Input
            header={Strings.default.REPEAT_EMAIL_ADDRESS[config.language]}
            value={repeatEmailInput}
            onChange={value => this.setState({ repeatEmailInput: value })}
          />
          {Constants.WHITE_LABEL.features.usePhone ? (
            <Input
              header={Strings.default.PHONE_NUMBER[config.language]}
              value={phoneInput}
              onChange={value => this.setState({ phoneInput: value })}
            />
          ) : null}
          <Input
            header={Strings.default.PASSWORD[config.language]}
            type={'password'}
            value={passwordInput}
            onChange={value => this.setState({ passwordInput: value })}
          />
          <Input
            header={Strings.default.REPEAT_PASSWORD[config.language]}
            type={'password'}
            value={repeatPasswordInput}
            onChange={value => this.setState({ repeatPasswordInput: value })}
          />
          <Button2
            onClick={() => this.create()}
            header={Strings.default.CREATE_ACCOUNT[config.language]}
            loading={user.isFetching || user.isSigningIn}
          />
        </div>
      </div>
    )
  }
}

const Input = ({ header = '', value, onChange, type }) => {
  return (
    <TextInput
      width={'100%'}
      header={header}
      type={type}
      value={value}
      onChange={value => onChange(value)}
      underlineFocusStyle={{
        borderColor: Constants.WHITE_LABEL.colors.primary
      }}
      floatingLabelFocusStyle={{ color: Constants.WHITE_LABEL.colors.primary }}
    />
  )
}

function mapStateToProps({ user, config, data }) {
  return { user, config, data }
}

function mapDispatchToProps(dispatch) {
  return bindActionCreators({ ...userActions, ...configActions }, dispatch)
}

export default connect(mapStateToProps, mapDispatchToProps)(SignUp)



// WEBPACK FOOTER //
// ./src/components/pages/preLogin/SignUp/index.js